export function getBottomOffset(element: HTMLElement): number {
  const { bottom } = element.getBoundingClientRect();
  return window.innerHeight - bottom;
}
